import type { ReactNode } from 'react';

import { AlertCircle, Check, CheckCircle2, WavesIcon } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import {
  type LifecycleState,
  lifecycleLabels,
} from '@/models/lifecycleState';

const lifecycleIcons: Record<LifecycleState, ReactNode> = {
  draft: <WavesIcon />,
  dirty: <AlertCircle />,
  ready: <CheckCircle2 />,
  published: <Check />,
};

export interface StateBadgeProps {
  state: LifecycleState;
  size?: 'default' | 'sm';
  /** When true, snapshot list selection styling overrides lifecycle colors. */
  selected?: boolean;
  className?: string;
  children?: ReactNode;
}

export const StateBadge = ({
  state,
  size = 'default',
  selected,
  className,
  children,
}: StateBadgeProps) => {
  return (
    <Badge
      variant="outline"
      className={cn(
        'transition-all state',
        state,
        selected && 'bg-primary/20 border-primary/70 border',
        size === 'sm' && 'px-1.5 py-0 text-[10px]',
        className,
      )}
    >
      {lifecycleIcons[state]}
      {children ?? <span>{lifecycleLabels[state]}</span>}
    </Badge>
  );
};
